var React = require('react');

function IconMail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon-mail","stroke":"currentColor","fill":"none"},React.createElement("g",{"id":"mail-icon","transform":"translate(1.000000, 1.000000)"},[React.createElement("rect",{"id":"Rectangle-21","x":"0","y":"0","width":"14","height":"10","rx":"1.5","key":0}),React.createElement("polyline",{"id":"Path-22","strokeLinecap":"round","strokeLinejoin":"round","points":"0.519760813 0.500399501 7 5 13.5116327 0.500399501","key":1})])));
}

IconMail.defaultProps = {"viewBox":"0 0 16 12"};

module.exports = IconMail;

IconMail.default = IconMail;
